<template>
  <div class="blank_layout">
    <router-view></router-view>
  </div>
</template>
<script>
import { Validator } from 'vee-validate';
export default {
  name: "Blank",
  mounted() {
    const rawLang = navigator.language || navigator.userLanguage || 'es';
    const browserLanguaje = rawLang.substring(0, 2);
    const lang = this.$route.query.lang || browserLanguaje;

    const supportedLanguages = ['es', 'en'];
    if (supportedLanguages.includes(lang)) {
      this.$i18n.locale = lang;
      Validator.localize(lang)
    } else {
      this.$i18n.locale = 'es';
    }
  }
};    
</script>
